<script setup>
const props = defineProps({
  eyebrow: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  copy: {
    type: Object,
    default: null,
  },
  image: {
    type: Array,
    default: null,
  },
  date: {
    type: String,
    default: null,
  },
  wideText: {
    type: Boolean,
    default: false,
  },
  startDate: {
    type: String,
    default: null,
  },
  endDate: {
    type: String,
    default: null,
  },
  addPageHero: {
    type: Boolean,
    default: true,
  },
  titleFont:{
    type: Boolean,
    default: false,
  },
  enableSidePanel: {
    type: Boolean,
    default: false,
  },
})
console.log(props)
const formattedDate = computed(() => {
  if (!props.date) {
    return
  }
  const dateString = new Date(props.date).toLocaleDateString()
  const dateArray = dateString.split('/')
  return [
    dateArray[0].padStart(2, '0'),
    dateArray[1].padStart(2, '0'),
    dateArray[2].slice(-2),
  ].join('/')
})

const formattedStartDate = computed(() => {
  if (!props.startDate) {
    return
  }
  const dateString = new Date(props.startDate).toLocaleDateString()
  const dateArray = dateString.split('/')
  return [
    dateArray[0].padStart(2, '0'),
    dateArray[1].padStart(2, '0'),
    dateArray[2].slice(-2),
  ].join('/')
})
const formattedEndDate = computed(() => {
  if (!props.endDate) {
    return
  }
  const dateString = new Date(props.endDate).toLocaleDateString()
  const dateArray = dateString.split('/')
  return [
    dateArray[0].padStart(2, '0'),
    dateArray[1].padStart(2, '0'),
    dateArray[2].slice(-2),
  ].join('/')
})
</script>

<template>
  <section :class="{'page-hero': addPageHero, 'page-hero--wide': wideText }">
    <div class="page-hero__inner">
      <SectionHeader
        :eyebrow="eyebrow"
        :date="formattedDate"
        :startDate="formattedStartDate"
        :endDate="formattedEndDate"
        :title="title"
        :copy="copy"
        animate
        level="h1"
        :size="titleFont ? 'x' : 's'"
        :enableSidePanel="enableSidePanel"

      />

      <AnimatedImage v-if="image" :media="image[0]" class="page-hero__image" />

      <slot />
    </div>
  </section>
</template>

<style lang="scss">
// Utils
@import 'styles/utils/variables';
@import 'styles/utils/functions';
@import 'styles/utils/timing-functions';

// Vendors
@import 'styles/vendors/sass-mq/mq';

.page-hero {
  display: block;
  padding: 128px 0 2px;

  @include mq($from: 'l') using ($from) {
    padding-top: 250px;
    padding-bottom: 20px;
  }

  &__inner {
    max-width: gs(6, 5, 'xxxs');
    width: 100%;
    margin: 0 auto;
    text-align: center;

    @include mq($from: 'l') using ($from) {
      max-width: gs(18, 17, 'l');
    }
  }

  &__title {
    margin-bottom: 55px;
  }

  &__copy {
    width: 100%;
    margin: 0 auto;

    @include mq($from: 'l') using ($from) {
      max-width: gs(12, 11, 'l');
    }
  }

  &__image {
    margin: 72px auto 0;
    @include mq($from: 'l') using ($from) {
      margin-top: 115px;
      max-width: gs(20, 19, 'l');
    }
  }

  &--wide {
    .section-header__headline {
      margin-left: auto;
      margin-right: auto;

      @include mq($until: 'm') using ($until) {
        order: 3;
      }

      @include mq($from: 'm') using ($from) {
        max-width: gs(4, 3, 'xxxs');
      }

      @include mq($from: 'l') using ($from) {
        max-width: gs(14, 13, 'l');
      }
    }

    .section-header__divider {
      @include mq($until: 'm') using ($until) {
        order: 2;
        margin-bottom: 18px;
      }
    }

    .section-header__copy {
      margin-left: auto;
      margin-right: auto;

      @include mq($until: 'm') using ($until) {
        margin-top: 32px;
        order: 3;
      }

      @include mq($from: 'm') using ($from) {
        max-width: gs(5, 4, 'xxxs');
      }

      @include mq($from: 'l') using ($from) {
        max-width: gs(12, 11, 'l');
      }
    }
  }
}
</style>
